import { SharedValue, useAnimatedReaction, useSharedValue } from "react-native-reanimated";
import positiveModWorklet from "src/helpers/mathHelpers/positiveModWorklet";
import { WheelProps } from "../types";

/**
 * Calculate the index of the active item (item at the top of the wheel)
 * and calls `onActiveIndexChangeWorklet` with that index when it changes.
 */
const WheelActiveIndexManagement = ({
	theta,
	rotationOffset,
	numSegments,
	onActiveIndexChangeWorklet,
}: {
	theta: SharedValue<number>;
	rotationOffset: number;
	numSegments: number;
} & Pick<WheelProps, "onActiveIndexChangeWorklet">) => {
	// `activeIndexSV` = index of the item that's at the top of the wheel
	const activeIndexSV = useSharedValue(0);

	useAnimatedReaction(
		() => {
			return theta.value;
		},
		(theta) => {
			"worklet";
			// Inverse theta (spinning clockwise means the new active item is counter-clockwise of the current active item)
			// and offset with initial rotation (which causes top of the wheel to be item at index = 3)
			const thetaWithOffset = -theta + rotationOffset;
			const thetaPos = positiveModWorklet(thetaWithOffset, 2 * Math.PI);
			const newActiveIndex = positiveModWorklet(
				Math.floor(thetaPos / ((2 * Math.PI) / numSegments) - 0.5),
				numSegments,
			);
			if (newActiveIndex !== activeIndexSV.value) {
				activeIndexSV.value = newActiveIndex;
				onActiveIndexChangeWorklet?.(newActiveIndex);
			}
		},
		[theta, onActiveIndexChangeWorklet],
	);

	return null;
};

export default WheelActiveIndexManagement;
